import { useTranslation } from 'react-i18next'

import { SliderMark } from 'components/Form/Slider/types'
import { TRAFFIC_AFFECTED_VALUES } from './constants'

export const useTrafficAffectedMarks = (): SliderMark[] => {
  const { t } = useTranslation('features/domain')

  return [
    {
      description: {
        color: 'warning',
        from: 0,
        title: t('form.viewabilityTools.trafficAffected.warning', {
          value: TRAFFIC_AFFECTED_VALUES.WARNING,
        }),
      },
      value: TRAFFIC_AFFECTED_VALUES.WARNING,
    },
    {
      label: t('form.viewabilityTools.trafficAffected.default', {
        value: TRAFFIC_AFFECTED_VALUES.DEFAULT,
      }),
      value: TRAFFIC_AFFECTED_VALUES.DEFAULT,
    },
  ]
}
